<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { PanelDisagreementsReportReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";

    @Component({
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propRm: { type: Object, required: false, default: null },
        }
    })
    export default class DisagreementsReportDialog extends Vue
    {
        get opened(): boolean { return this.$props.propOpened; }
        get rm(): PanelDisagreementsReportReadModel { return this.$props.propRm as PanelDisagreementsReportReadModel; }

        get questions() { return this.rm?.Questions ?? []; }

        showQuestion(questionId: number)
        {
            this.$emit('show-question', questionId);
        }

        close()
        {
            this.$emit('close-dialog');
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened === true">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Disagreements</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h3 v-if="!rm">
                            <i class="fa fa-spinner fa-spin"></i> Loading...
                        </h3>
                        <div v-if="rm" class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Question</th>
                                        <th>Context</th>
                                        <th>Disagreement</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="q in questions" :key="q.Id">
                                        <td>{{q.Title}}</td>
                                        <td>
                                            <span>{{q.ContextName}}</span>
                                            <small v-if="q.ContextPath">
                                                <br />
                                                Path: {{q.ContextPath}}
                                            </small>
                                        </td>
                                        <td>{{q.DisagreementStatus}}</td>
                                        <td class="text-center">
                                            <a class="text-primary" @click="showQuestion(q.Id)">show</a>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>